export default "__VITE_ASSET__wxLvlb7e__"